import tokens from '@veneer/tokens';
import styled from 'styled-components';

export const OptionsContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${tokens.layout.size5};
`;
